import { atom } from "recoil";

export const currentSelectionsAtom = atom({
    key: 'currentSelectionsAtom',
    default: {}
});
